module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.1219512195122,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#043f61"
					},
					{
						"y": 90.2439024390244,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.92682926829268,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.17073170731707,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 68.29268292682927,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.14814814814815,
						"dataLabels": {
							"enabled": false,
							"format": "106"
						},
						"color": "#043f61"
					},
					{
						"y": 90.74074074074075,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.03703703703704,
						"dataLabels": {
							"enabled": false,
							"format": "94"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.62962962962963,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#09472e"
					},
					{
						"y": 67.5925925925926,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.875,
						"dataLabels": {
							"enabled": false,
							"format": "124"
						},
						"color": "#043f61"
					},
					{
						"y": 89.0625,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.9375,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.6875,
						"dataLabels": {
							"enabled": false,
							"format": "102"
						},
						"color": "#09472e"
					},
					{
						"y": 71.09375,
						"dataLabels": {
							"enabled": false,
							"format": "91"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.92147806004618,
						"dataLabels": {
							"enabled": false,
							"format": "424"
						},
						"color": "#043f61"
					},
					{
						"y": 94.22632794457274,
						"dataLabels": {
							"enabled": false,
							"format": "408"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.99307159353349,
						"dataLabels": {
							"enabled": false,
							"format": "394"
						},
						"color": "#0d4440"
					},
					{
						"y": 89.37644341801386,
						"dataLabels": {
							"enabled": false,
							"format": "387"
						},
						"color": "#09472e"
					},
					{
						"y": 80.13856812933025,
						"dataLabels": {
							"enabled": false,
							"format": "347"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#043f61"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0d4440"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.77777777777777,
						"dataLabels": {
							"enabled": false,
							"format": "88"
						},
						"color": "#043f61"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "78"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "66"
						},
						"color": "#09472e"
					},
					{
						"y": 57.77777777777777,
						"dataLabels": {
							"enabled": false,
							"format": "52"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.78714859437751,
						"dataLabels": {
							"enabled": false,
							"format": "241"
						},
						"color": "#043f61"
					},
					{
						"y": 86.74698795180723,
						"dataLabels": {
							"enabled": false,
							"format": "216"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.73092369477911,
						"dataLabels": {
							"enabled": false,
							"format": "206"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.89558232931726,
						"dataLabels": {
							"enabled": false,
							"format": "184"
						},
						"color": "#09472e"
					},
					{
						"y": 56.22489959839358,
						"dataLabels": {
							"enabled": false,
							"format": "140"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.87234042553192,
						"dataLabels": {
							"enabled": false,
							"format": "414"
						},
						"color": "#043f61"
					},
					{
						"y": 89.36170212765957,
						"dataLabels": {
							"enabled": false,
							"format": "378"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.34278959810875,
						"dataLabels": {
							"enabled": false,
							"format": "361"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.90543735224587,
						"dataLabels": {
							"enabled": false,
							"format": "338"
						},
						"color": "#09472e"
					},
					{
						"y": 66.19385342789597,
						"dataLabels": {
							"enabled": false,
							"format": "280"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 67.6056338028169,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#043f61"
					},
					{
						"y": 56.33802816901409,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#0c4250"
					},
					{
						"y": 54.929577464788736,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0d4440"
					},
					{
						"y": 40.845070422535215,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 23.943661971830984,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.63636363636364,
						"dataLabels": {
							"enabled": false,
							"format": "103"
						},
						"color": "#043f61"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.27272727272727,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.81818181818181,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#09472e"
					},
					{
						"y": 64.54545454545455,
						"dataLabels": {
							"enabled": false,
							"format": "71"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.05882352941177,
						"dataLabels": {
							"enabled": false,
							"format": "198"
						},
						"color": "#043f61"
					},
					{
						"y": 78.92156862745098,
						"dataLabels": {
							"enabled": false,
							"format": "161"
						},
						"color": "#0c4250"
					},
					{
						"y": 75.98039215686273,
						"dataLabels": {
							"enabled": false,
							"format": "155"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.62745098039215,
						"dataLabels": {
							"enabled": false,
							"format": "140"
						},
						"color": "#09472e"
					},
					{
						"y": 58.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "120"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.51474530831099,
						"dataLabels": {
							"enabled": false,
							"format": "360"
						},
						"color": "#043f61"
					},
					{
						"y": 80.16085790884718,
						"dataLabels": {
							"enabled": false,
							"format": "299"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.7479892761394,
						"dataLabels": {
							"enabled": false,
							"format": "290"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.92225201072387,
						"dataLabels": {
							"enabled": false,
							"format": "272"
						},
						"color": "#09472e"
					},
					{
						"y": 62.19839142091153,
						"dataLabels": {
							"enabled": false,
							"format": "232"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.878048780487809,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.128205128205132,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.108108108108103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.851851851851849,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.547169811320753,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.081632653061229,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.510638297872342,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.116279069767447,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.064516129032262,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.508771929824561,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.272727272727275,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.784313725490192,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.0785219399538146,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.7735849056603765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4313725490196068,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.7766497461928932,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.335917312661502,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2222222222222254,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.212121212121215,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2128514056224855,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.373443983402487,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.629629629629628,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.679611650485432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.913043478260864,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.127659574468088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.4973544973545,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.371191135734067,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.159763313609467,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -32.3943661971831,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.500000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.64102564102564,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.379310344827594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.36363636363636,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.621359223300976,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.058823529411762,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.126582278481012,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.941176470588236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.686868686868685,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.7267080745341574,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.677419354838712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.4852546916890104,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.94444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.0100334448160515,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.206896551724139,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=41"
			},
			{
				"x": 9,
				"text": "30-39<br>n=108"
			},
			{
				"x": 15,
				"text": "40-49<br>n=128"
			},
			{
				"x": 21,
				"text": ">=50<br>n=433"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=15"
			},
			{
				"x": 34,
				"text": "30-39<br>n=90"
			},
			{
				"x": 40,
				"text": "40-49<br>n=249"
			},
			{
				"x": 46,
				"text": ">=50<br>n=423"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=71"
			},
			{
				"x": 59,
				"text": "30-39<br>n=110"
			},
			{
				"x": 65,
				"text": "40-49<br>n=204"
			},
			{
				"x": 71,
				"text": ">=50<br>n=373"
			}
		],
		"dataTable": {
			"MSM:<30": [
				41,
				39,
				37,
				34,
				30,
				28
			],
			"MSM:30-39": [
				108,
				106,
				98,
				94,
				86,
				73
			],
			"MSM:40-49": [
				128,
				124,
				114,
				110,
				102,
				91
			],
			"MSM:>=50": [
				433,
				424,
				408,
				394,
				387,
				347
			],
			"Non-MSM:<30": [
				15,
				14,
				14,
				12,
				6,
				6
			],
			"Non-MSM:30-39": [
				90,
				88,
				84,
				78,
				66,
				52
			],
			"Non-MSM:40-49": [
				249,
				241,
				216,
				206,
				184,
				140
			],
			"Non-MSM:>=50": [
				423,
				414,
				378,
				361,
				338,
				280
			],
			"Unknown:<30": [
				71,
				48,
				40,
				39,
				29,
				17
			],
			"Unknown:30-39": [
				110,
				103,
				90,
				85,
				79,
				71
			],
			"Unknown:40-49": [
				204,
				198,
				161,
				155,
				140,
				120
			],
			"Unknown:>=50": [
				373,
				360,
				299,
				290,
				272,
				232
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_5.json
// module id = 203
// module chunks = 0